import { apiClient } from '@/api/client';
import type { CurrentUser } from '@/types';

export async function getMe(): Promise<CurrentUser> {
  const { data } = await apiClient.get<CurrentUser>('/me');
  return data;
}
